import initCookies from './components/cookies';
import initSplash from './components/home/splash';

// Initialise Cookies first so show() works in splash
initCookies();

// Splash
const splashEl = document.querySelector('.js-splash');

if (splashEl) {
    initSplash(splashEl);
}
